import React, { useState, useRef, useEffect } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

export default function ModuleNavbar() {
     const [isMenuOpen, setIsMenuOpen] = useState(false);

      const headerRef = useRef(null);
    
      const toggleMenu = () => {
        setIsMenuOpen((prev) => !prev);
      };
    
      
      useEffect(() => {
        const handleClickOutside = (event) => {
          if (
            headerRef.current &&
            !headerRef.current.contains(event.target)
          ) {
            setIsMenuOpen(false);
          }
        };
    
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
      }, []);
    
  return (
    <React.Fragment>
       <header>
        <section className="nav-section" ref={headerRef}>
            <nav className="main-navbar" aria-label="Main navigation">
                <NavLink to='/' className="logo"  style={{cursor:"pointer"}}> 
                    <img src="./assets/images/credence-pay-logo.png" alt="Credence Resource Management, LLC logo" width="auto"/>
                </NavLink>
                <button className="main-menu-toggle" aria-label="Toggle navigation menu" aria-expanded="false" aria-controls="main-navigation" onClick={toggleMenu}>☰</button>
                            <ul className={`main-nav-links ${isMenuOpen ? "active" : ""}`}>

                    <li><Link to="/" className="main-nav">Home</Link></li>
                    <li><Link to="/About-Us" className="main-nav">About Us</Link></li>
                    <li>
                        <Link to="#" className="main-nav" aria-haspopup="true" aria-expanded="false">Rights & Policies ▾ </Link>
                        <div className="sub-menu" role="submenu">
                            <Link to="/privacy.html">Privacy</Link>
                            <Link to="/legal.html">Your Legal Rights</Link>
                            <Link to="/refund-policy.html">Refund Policy</Link>
                            <Link to="/sms-policy.html">SMS Policy</Link>
                        </div>
                    </li>
                    <li><Link to="/Contact-Us" className="">Contact</Link></li>
                </ul>
            </nav>
        </section>
    </header>
    </React.Fragment>
  );
}
